import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectTagId } from "../redux/slices/filterSlice";

export default function Tags() {
  const tags = ["All", "Meet", "Vegetarian", "Grill", "Spicy", "Pizza-Pie"];

  const tagId = useSelector((state) => state.filter.tagId);
  const dispatch = useDispatch();

  return (
    <div className="categories">
      <ul>
        {tags.map((tag, id) => {
          return (
            <li
              key={id + tag}
              className={tagId === id ? "active" : ""}
              onClick={() => dispatch(selectTagId(id))}
            >
              {tag}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
